import { createStore, Store, applyMiddleware } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { composeWithDevTools } from 'redux-devtools-extension';
import InitialState from './initialState';
import { IInitialState } from './models';
import reducer from './reducers';
import rootSaga from './rootSaga';

export const sagaMiddleware = createSagaMiddleware();

const configureStore = (): Store<IInitialState> => {
	const enhancer = composeWithDevTools(applyMiddleware(sagaMiddleware));

	const store = createStore(reducer, InitialState, enhancer) as Store<
	IInitialState
	>;

	sagaMiddleware.run(rootSaga);
	return store;
};

export default configureStore;
